"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Surface = undefined;

var _glReact = require("gl-react");

var _raf = require("raf");

var _raf2 = _interopRequireDefault(_raf);

var _GLViewDOM = require("./GLViewDOM");

var _GLViewDOM2 = _interopRequireDefault(_GLViewDOM);

require("webgltexture-loader-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderLessElement = "span";

var mapRenderableContent = function mapRenderableContent(el) {
  return el instanceof Element ? el.firstElementChild : null;
};

var Surface = exports.Surface = (0, _glReact.createSurface)({
  GLView: _GLViewDOM2.default,
  RenderLessElement: RenderLessElement,
  mapRenderableContent: mapRenderableContent,
  requestFrame: _raf2.default,
  cancelFrame: _raf2.default.cancel
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/gl-react-dom/lib/index.js
// module id = 883
// module chunks = 0